import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { ErrorHandlerService } from '../services/error-handler.service';
import { UserService } from '../services/user.service';
import { map } from 'rxjs/operators';

export interface IAuth {
  salon: Object;
  token: string;
  user: Object;
}

export interface IMagicCodeResponse {
  status: string;
}

export interface IClientInfo {
  firstName: string;
  lastName: string;
  phone: string;
}

@Injectable()
export class LoginService {
  constructor(private http: HttpClient,
    private userService: UserService,
    private errorHandlerService: ErrorHandlerService) { }

  public loginUser(username: string, password: string): Observable<IAuth> {
    const apiURL = environment.API_ROOT + '/auth/clients';
    const body = {
      username: username,
      password: password,
      salonID: this.userService.getSalon().getId()
    }

    return new Observable<IAuth>((observer) => {
      this.http.post(apiURL, body)
        .pipe(
          map((res: any) => {
            return res;
          })
        )
        .subscribe(
          (response) => {
            const data = {
              salon: response.data.salon,
              token: response.data.token,
              user: response.data.user
            };

            observer.next(data);
            observer.complete();
          },
          (error) => {
            observer.error(this.errorHandlerService.handleError(error));
            observer.complete();
          }
        );
    });
  }

  public requestMagicCode(email: string, salonID: number, clientInfo?: IClientInfo): Observable<IMagicCodeResponse> {
    const apiURL = environment.API_ROOT + '/auth/otp/send';
    const body: any = {
      email: email,
      salonID: salonID
    };

    if (clientInfo) {
      body.firstName = clientInfo.firstName;
      body.lastName = clientInfo.lastName;
      body.phone = clientInfo.phone;
    }

    return new Observable<IMagicCodeResponse>((observer) => {
      this.http.post(apiURL, body)
        .pipe(
          map((res: any) => {
            return res;
          })
        )
        .subscribe(
          (response) => {
            observer.next({ status: response.data.status });
            observer.complete();
          },
          (error) => {
            observer.error(this.errorHandlerService.handleError(error));
            observer.complete();
          }
        );
    });
  }

  public verifyMagicCode(email: string, code: string, salonID: number): Observable<IAuth> {
    const apiURL = environment.API_ROOT + '/auth/otp/verify';
    const body = {
      email: email,
      code: code,
      salonID: salonID
    };

    return new Observable<IAuth>((observer) => {
      this.http.post(apiURL, body)
        .pipe(
          map((res: any) => {
            return res;
          })
        )
        .subscribe(
          (response) => {
            const data = {
              salon: response.data.salon,
              token: response.data.token,
              user: response.data.user
            };

            observer.next(data);
            observer.complete();
          },
          (error) => {
            observer.error(this.errorHandlerService.handleError(error));
            observer.complete();
          }
        );
    });
  }

  public facebookLogin(fbID: string, firstName: string, lastName: string, email: string): Observable<IAuth> {
    const apiURL = environment.API_ROOT + '/auth/clients/facebook';
    const body = {
      fbID: fbID,
      firstName: firstName,
      lastName: lastName,
      email: email,
      salonID: this.userService.getSalon().getId(),
      iOSID: undefined,
      androidID: undefined
    }

    return new Observable<IAuth>((observer) => {
      this.http.post(apiURL, body)
        .pipe(
          map((res: any) => {
            return res;
          })
        )
        .subscribe(
          (response) => {
            const data = {
              salon: response.data.salon,
              token: response.data.token,
              user: response.data.user
            };

            observer.next(data);
            observer.complete();
          },
          (error) => {
            observer.error(this.errorHandlerService.handleError(error));
            observer.complete();
          }
        );
    });
  }

}